<footer class="footer-wrapper pt-5">
  <div class="container">
    <div class="row footer">
      <div class="col">
        <div class="navbar-brand p-0">
          <img [src]="footerData.logo_src" alt="Company logo">
        </div>
        <hr class="d-md-none my-4">
      </div>
      @for (column of footerData.sections; track column) {
        <div class="col-md">
          <h3 class="h4 pb-4">
            {{ column.title }}
          </h3>
          <ul class="list-unstyled">
            @for (card of column.subSections; track card; let i = $index) {
              <li class="pb-4">
                @if (card.title) {
                  <span id="footer-{{ card.title }}-{{i}}">{{ card.title }}</span>
                }
                @if (card.description) {
                  <a (click)="redirect(card.link, card.linkType)"
                  class="rs-btn-link fw-700 d-block pt-1 text-left">{{ card.description }}</a>
                }
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
  <div class="version">
    <span [innerHTML]="version"></span>
  </div>
</footer>
